module.exports = new __parcel__URL__("step-integrations.2c6dc384.svg").toString();